// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const INITIALIZED = '@auth/INITIALIZED';
export const RELOAD_PERMISSIONS = '@auth/RELOAD_PERMISSIONS';
export const UPDATE_PROFILE = '@auth/UPDATE_PROFILE';
